import { Injectable } from '@angular/core'
import { TranslateService } from '@ngx-translate/core'
import { IdentityService } from 'main/services/identity.service'
import { ShowInExplorerService } from 'media/services/showInExplorer.service'
import { PanelService } from 'panel/services/panel.service'
import { MediaOperationsService } from '../services/mediaOperations.service'
import { BaseOperation } from './base'

@Injectable({ providedIn: 'root' })
class ShowLocallyOp extends BaseOperation {
  icon = 'far fa-folder-open'
  showInContextMenu = true
  showInAssetView = true
  supportsDirs = true
  supportsBundles = true
  weight = 100

  constructor (
    private showInExplorer: ShowInExplorerService,
    private translate: TranslateService,
    private panel: PanelService,
    private identity: IdentityService,
  ) {
    super()
    this.label = showInExplorer.getShowLabel()
  }

  isVisibleFor () {
    return !this.identity.user?.isExternal
  }

  isEnabledForDir (dir) {
    return dir.present && this.identity.hasPermission('client:access') && !this.panel.active
  }

  isEnabledForBundle (bundle) {
    return bundle?.mainfile?.present && this.identity.hasPermission('client:access') && !this.panel.active
  }

  async runForDir (dir) {
    this.showInExplorer.showFile(dir)
  }

  async runForBundle (bundle) {
    this.showInExplorer.showBundle(bundle)
  }
}

MediaOperationsService.register(ShowLocallyOp)
